import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ISDateTimePickerComponent } from './is-date-time-picker.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { CdkMenuModule } from '@angular/cdk/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OverlayModule } from '@angular/cdk/overlay';
import { SharedModule } from '../shared.module';

const materialModules = [
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatIconModule,
    CdkMenuModule,
    OverlayModule,
    MatTooltipModule,
    SharedModule
];

@NgModule({
    declarations: [ISDateTimePickerComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ...materialModules
    ],
    exports: [ISDateTimePickerComponent,MatDatepickerModule],
    providers: [{ provide: MAT_DATE_LOCALE, useValue: 'pt' }, DatePipe],
})
export class ISDateTimePickerModule {}